document.addEventListener("DOMContentLoaded", function () {
  const calcButton = document.getElementById("calcButton");

  document.getElementById("waxWeight").addEventListener("input", function () {
    document.getElementById("cautionMessage").innerText = "";
  });

  function getBaseVolume(volume) {
    let tax = 1.1;
    if (volume <= 190) {
      return 3500 * tax;
    } else if (volume <= 470) {
      return 4500 * tax;
    } else if (volume <= 960) {
      return 6000 * tax;
    } else if (volume <= 1440) {
      return 7500 * tax;
    } else if (volume <= 1920) {
      return 9000 * tax;
    } else if (volume <= 2400) {
      return 10500 * tax;
    } else if (volume <= 2880) {
      return 12000 * tax;
    } else if (volume <= 3360) {
      return 13500 * tax;
    } else if (volume <= 3850) {
      return 15000 * tax;
    } else if (volume <= 4330) {
      return 16500 * tax;
    } else if (volume <= 4810) {
      return 18000 * tax;
    } else {
      return 0;
    }
  }

  calcButton.addEventListener("click", function () {
    const metalType = document.getElementById("metalTypeSelector").value;
    const volume = parseFloat(document.getElementById("volume").value);
    let waxWeight = parseFloat(document.getElementById("waxWeight").value);

    const metals = {
      pt100: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT1000",
      }, // PT1000
      pt950h: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT950H",
      }, // PT950H
      pt900: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 770,
        name: "PT900",
      }, // PT900
      k24: {
        specificGravity: 20,
        unitCastPrice: 110,
        baseCost: 880,
        name: "K24",
      }, // K24
      k18yg: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K18YG64",
      }, // K18YG(6:4)
      k18pg: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K18PG28",
      }, // K18
      k18: {
        specificGravity: 16,
        unitCastPrice: 110,
        baseCost: 550,
        name: "K1855",
      }, // K18
      k10yg: {
        specificGravity: 12,
        unitCastPrice: 110,
        baseCost: 770,
        name: "K10YG",
      }, // K10
      sv950: {
        specificGravity: 10,
        unitCastPrice: 90,
        baseCost: 440,
        name: "SV950",
      }, // SV950
      sv925: {
        specificGravity: 10,
        unitCastPrice: 90,
        baseCost: 440,
        name: "SV925",
      }, // SV925
    };

    let selectedMetal = metals[metalType];
    let castWeight = waxWeight * selectedMetal.specificGravity;
    let totalCost = castWeight * selectedMetal.unitCastPrice;

    if (!isNaN(volume)) {
      if (volume >= 2710) {
        document.getElementById("inquiryMessage").innerText =
          "大きいサイズは別途お見積りになります。お問い合わせください";
        return;
      } else {
        document.getElementById("inquiryMessage").innerText = "";
      }

      // Convert volume to wax weight and update input field
      waxWeight = volume / 1000;
      document.getElementById("waxWeight").value = waxWeight.toFixed(2);

      // Notify the user that the wax weight has been auto-calculated
      document.getElementById("cautionMessage").innerText =
        "WAX重量が自動計算されました。";

      // Recalculate cast weight and total cost
      castWeight = waxWeight * selectedMetal.specificGravity;
      totalCost = castWeight * selectedMetal.unitCastPrice;
    }

    let priceElement = document.querySelector(
      `#${selectedMetal.name} td:nth-child(2)`,
    );
    let metalPrice = parseFloat(
      priceElement.innerText.replace("円/g", "").replace(",", ""),
    );

    if (isNaN(metalPrice)) {
      document.getElementById("cautionMessage").innerText =
        "地金の価格取得に失敗しました。";
      return;
    }

    if (totalCost < selectedMetal.baseCost) {
      document.querySelector("#result span#totalCost").innerText =
        `(*最低工賃になります) ${selectedMetal.baseCost.toFixed(0)}`;
      castingCost = selectedMetal.baseCost;
    } else {
      document.querySelector("#result span#totalCost").innerText =
        totalCost.toLocaleString("ja-JP", {
          style: "decimal",
          currency: "JPY",
        });
      castingCost = totalCost;
    }

    let tax = 1.1;
    let metalCost = castWeight * metalPrice;
    let modelCost = getBaseVolume(volume); // 造形工賃（税込）
    let totalMetalCost = Math.round(metalCost / 0.86 * tax); // 地金代（税込）
    let grandTotalCost = castingCost + modelCost + totalMetalCost; // 合計金額（税込）

    document.querySelector("#result span#castWeight").innerText =
      castWeight.toFixed(1);

    document.querySelector("#result span#unitCastPrice").innerText =
      selectedMetal.unitCastPrice;

    document.querySelector("#result span#modelCost").innerText =
      modelCost.toLocaleString("ja-JP", {
        style: "decimal",
        currency: "JPY",
      });

    document.querySelector("#result span#metalCost").innerText =
      totalMetalCost.toLocaleString("ja-JP", {
        style: "decimal",
        currency: "JPY",
      });

    document.querySelector("#result span#grandTotalCost").innerText =
      grandTotalCost.toLocaleString("ja-JP", {
        style: "decimal",
        currency: "JPY",
      });
  });
});
